module.exports = __webpack_public_path__ + "img/arrow.b96e191d.svg";